<div class="main-card skeleton-item" yatTabSelectable (tabSelect)="selectCard($event)">
  <ng-content></ng-content>
  <div *ngIf="isMinified" class="ico-container">
    <yat-icon class="chevron-icon" *ngIf="isMobile() && isMinified; else cog" [name]="showIcon ? 'chevron-right' : iconName"> </yat-icon>
    <ng-template #cog>
      <yat-icon id="9c70c4cc-c453-458a-80f6-1fdbf7c0369d" class="cog-icon" *ngIf="isMinified" name="cog-duo"></yat-icon>
    </ng-template>
  </div>
</div>
